module.exports = __webpack_public_path__ + "img/ottolenghi_lentils.5286d9db.jpg";